<template>
  <div id="app">
    <div class="ajax_loading" v-if="$store.getters.isLoading">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <UsageExtendPopup
      :visible.sync="showExtendPopup"
      :show-point-charge.sync="showChargePointPopup"
      @onCharge="
        () => {
          u.setState(self, { showExtendPopup: false }, () => {
            u.toast(self, self.$t('more.usage_success'));
          });
        }
      "
    />
    <ChargePointPopup
      v-if="showChargePointPopup"
      :visible.sync="showChargePointPopup"
    />
    <router-view />
  </div>
</template>

<script>
import UsageExtendPopup from "./components/controls/popup/UsageExtendPopup";
import ChargePointPopup from "./components/controls/popup/ChargePointPopup";
import Utils from "./config/utils";
import VueDaumPostcode from "vue-daum-postcode";
import Vue from "vue";
Vue.use(VueDaumPostcode);

export default {
  name: "App",
  components: { UsageExtendPopup, ChargePointPopup, VueDaumPostcode },
  inject: ["eventBus"],
  mounted() {
    window.onmousewheel = function (event) {
      if (document.getElementsByClassName("modal-body").length != 0) {
        let currentST =
          document.getElementsByClassName("modal-body")[0].scrollTop;
        document.getElementsByClassName("modal-body")[0].scrollTop =
          currentST - event.wheelDeltaY;
      } else if (document.getElementsByClassName("scroll").length != 0) {
        let currentST = document.getElementsByClassName("scroll")[0].scrollTop;
        document.getElementsByClassName("scroll")[0].scrollTop =
          currentST - event.wheelDeltaY;
      }
    };
    var self = this;
    window.onpopstate = function (event) {
      if (self.modal.length > 0) {
        let target = self.modal.pop();
        target.$emit("update:visible", false);
      }
    };
    this.eventBus.$on("checkTicketAvailable", (callback) => {
      this.getProfile();
      if (this.myinfo.isTicketAvailable()) {
        callback();
      } else {
        Utils.showConfirm(
          this,
          this.$t("more.usage_expired_title") +
            "<br>" +
            "<div class='popup_msg_label_2 mt-2'>" +
            this.$t("more.usage_expired") +
            "</div>"
        ).then((result) => {
          if (result) {
            console.log("-------showpopup----------");
            this.showExtendPopup = true;
          }
        });
      }
    });
    this.eventBus.$on("setModal", (modalContext) => {
      self.modal.push(modalContext);
    });

    this.eventBus.$on("show_toast", () => {
      Utils.toast(this, this.$t("signup_info.signup_under_review"));
    });
    setInterval(() => {
      if (this.$store.getters.getLogOutNeed) {
        this.myinfo.clear();
        this.$perf.setString(this.$c.PREF_PARAMS.PHONE, "");
        this.$perf.setString(this.$c.PREF_PARAMS.CODE, "");
        this.$router.push("login");
        this.$store.commit("setLogOutNeed", false);
        // Utils.toast(this, this.$t('app_error.other_device_login'));
      }
    }, 2000);
  },
  data() {
    return {
      self: this,
      u: Utils,
      showExtendPopup: false,
      modal: [],
      showChargePointPopup: false,
    };
  },
  methods: {
    getProfile() {
      Utils.requestGet(this.$c.API.User.getProfile, {}).then((result) => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          this.myinfo.saveInfo();
          this.myinfo.loadInfo();
        } else {
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: KoreanGD11R;
  src: url(./assets/fonts/KoreanGD11R.ttf) format("truetype");
}
@font-face {
  font-family: KoreanGD12R;
  src: url(./assets/fonts/KoreanGD12R.ttf) format("truetype");
}
@font-face {
  font-family: KoreanGD13R;
  src: url(./assets/fonts/KoreanGD13R.ttf) format("truetype");
}
@font-face {
  font-family: KoreanGD14R;
  src: url(./assets/fonts/KoreanGD14R.ttf) format("truetype");
}
@font-face {
  font-family: KoreanGD15R;
  src: url(./assets/fonts/KoreanGD15R.ttf) format("truetype");
}
@font-face {
  font-family: KoreanGD16R;
  src: url(./assets/fonts/KoreanGD16R.ttf) format("truetype");
}
@font-face {
  font-family: KoreanGD17R;
  src: url(./assets/fonts/KoreanGD17R.ttf) format("truetype");
}
@font-face {
  font-family: KoreanGD18R;
  src: url(./assets/fonts/KoreanGD18R.ttf) format("truetype");
}
@font-face {
  font-family: KoreanGD19R;
  src: url(./assets/fonts/KoreanGD19R.ttf) format("truetype");
}
@import "./assets/css/vars";
div.ajax_loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  //background-color: rgba(0,0,0,0.4);
}
.popup_msg_label_2 {
  font-size: $fs_14;
  text-align: center;
  font-family: $korean_gd_12_r;
  line-height: 27px;
  color: $c_457fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue